import { FormHelperText } from '@mui/material';

export default function FieldHelperText({ children }) {
  return (
    <FormHelperText
      component="div"
      sx={{ ml: 0, mt: 0, mb: 1, fontStyle: 'italic', fontSize: '1rem' }}
    >
      {children}
    </FormHelperText>
  );
}
